import { FullScreenVideo } from "@components/fullScreenVideo";
import { Modal } from "@components/shared";
import ExperienceCard from "@components/spotprofile/experience-card";
import ExperiencesFilters, {
  type ExperiencesFilterOptions,
} from "@components/spotprofile/experiences-filters";
import SpotProfileLayout from "@layouts/SpotProfileLayout";
import Tab from "@components/spotprofile/tab";
import {
  getSpotCategories,
  getSpotInfo,
  getSpotTopExperiences,
} from "@lib/api";
import type {
  GetStaticPathsContext,
  GetStaticPropsContext,
  InferGetStaticPropsType,
} from "next";
import { useRouter } from "next/router";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "@hooks/useTranslation";
import { events, track } from "@shared/tracking";

import type { Locale } from "../../../i18n-config";
import { MainLayout } from "@layouts/MainLayout";
import Head from "next/head";

import aboutusImg2 from "../../../public/images/aboutus/aboutus-icon2.svg";
import aboutusImg3 from "../../../public/images/aboutus/aboutus-icon3.svg";


// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";
import Image from "next/image";

// import required modules
import { FreeMode, Pagination, Navigation, Autoplay } from "swiper";
import iconImg1 from "../../../public/images/bepartof/icon-toptraveller.png.webp";
import iconImg2 from "../../../public/images/bepartof/icon-business.png.webp";
import iconFullImg1 from "../../../public/images/bepartof/icon-toptraveller-full.png.webp";
import iconFullImg2 from "../../../public/images/bepartof/icon-business-full.png.webp";
import sendEmail from "@hooks/useSendEmail";
import { pickByLocale } from "@lib/utils";
import { toast } from "react-toastify";









export default function TheAppPage({
}) {
  const { t } = useTranslation();


  const router = useRouter();
  const locale = (router.locale ?? "en") as Locale;
  const description = pickByLocale(
    {
      en: "Book unique experiences in Barcelona, Marrakech, and Lisbon with beder. Discover the best activities and hotels through videos from other travelers. Press play, book, and enjoy the journey!",
      es: "Reserva experiencias únicas en Barcelona, Marrakech y Lisboa con beder. Descubre las mejores actividades y hoteles a través de vídeos de otros viajeros. ¡Dale al play, reserva y disfruta del viaje!",
      fr: "Réservez des expériences uniques à Barcelone, Marrakech et Lisbonne avec beder. Découvrez les meilleures activités et hôtels à travers des vidéos d’autres voyageurs. Appuyez sur play, réservez et profitez du voyage!",
    ru:"Бронируйте уникальные впечатления в Барселоне, Марракеше и Лиссабоне с beder. Открывайте лучшие развлечения и отели через видео от других путешественников. Нажмите «Play», забронируйте и наслаждайтесь путешествием!"
    },
    locale
  );



    const [selectedOption, setSelectedOption] = useState('opt1');
    const [travelerName, setTravelerName] = useState('');
    const [businessName, setBusinessName] = useState('');
    const [email, setEmail] = useState('');
    const [web, setWeb] = useState('');
    const [instagram, setInstagram] = useState('');
    const [tiktok, setTiktok] = useState('');
  
    const handleOptionChange = (event: { target: { value: any; }; }) => {
      console.log('handleOptionChange')

      const value = event.target.value;
      setSelectedOption(value);
      console.log(value)

    };

    const handleTravelerName = (event: { target: { value: any; }; }) => {
      const value = event.target.value;
      setTravelerName(value);
    };

    const handleBusinessName = (event: { target: { value: any; }; }) => {
      const value = event.target.value;
      setBusinessName(value);
    };

    const handleEmail = (event: { target: { value: any; }; }) => {
      const value = event.target.value;
      setEmail(value);
    };

    const handleWeb = (event: { target: { value: any; }; }) => {
      const value = event.target.value;
      setWeb(value);
    };

    const handleInstragram = (event: { target: { value: any; }; }) => {
      const value = event.target.value;
      setInstagram(value);
    };

    const handleTiktok = (event: { target: { value: any; }; }) => {
      const value = event.target.value;
      setTiktok(value);
    };

    const onSend = async () => {


      sendEmail('no.reply@bederapp.info',
      'Webside - Contact Us - ' + (selectedOption == 'opt1' ? 'Traveller' : 'Business'),
      (selectedOption == 'opt1' ? 
      (
        '  - Traveler Name: ' + travelerName + '\r\n' +
        ' - Email: ' + email + '\r\n' +
        ' - Instagram: ' + instagram + '\r\n' +
        ' - Tiktok: ' + tiktok + '\r\n'
      ) : 
      (
        '  - Business Name: ' + businessName + '\r\n' +
        ' - Email: ' + email + '\r\n' +
        ' - Web: ' + web + '\r\n' +
        ' - Instagram:' + instagram + '\r\n' +
        ' - Tiktok: ' + tiktok + '\r\n'
      )
      )
     );

     setTravelerName('');
     setEmail('');
     setInstagram('');
     setTiktok('');
     setBusinessName('');
     setWeb('');

     let msg = locale == 'es' ? 'Se ha enviado la información de contacto, en breve nos pondremos en contacto contigo.' :
     locale == 'en' ? 'Contact information has been sent, We will contact you shortly.' :
     locale == 'fr' ? 'Les informations de contact ont été envoyées, nous vous contacterons sous peu.' :
     locale == 'ru' ? 'Контактная информация отправлена, мы свяжемся с вами в ближайшее время.' :
     'Vous avez envoyé les informations de contact, en bref, nous réfléchirons en contact avec nous.'; 

toast(msg);


         


    };


    const scrolltoHash = function (element_id: string) {
      const element = document.getElementById(element_id)
      element?.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    }


  return (
    <MainLayout isFooter={true} isBlack={true}>
        <Head>
        <title>Beder</title>
        <link rel="icon" href="/favicon.ico" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta httpEquiv="ScreenOrientation" content="autoRotate:disabled" />
        <meta httpEquiv="Content-Language" content="en,es,fr"></meta>
        <meta name="description" content={description} />
        <meta
          property="og:image"
          content="https://beder-sales.s3.eu-west-3.amazonaws.com/prod/styles/thumbnail/thumbnail.jpg"
          data-addsearch="no_crop"
        ></meta>
      </Head>
      <section className="relative flex flex-col items-center justify-center   pt-12">
      
        <div className="-mt-[150px] flex flex-row h-screen overflow-x-auto w-screen align-center text-center content-center justify-center items-center"
        
        style={{
          backgroundImage: `url('https://storage.googleapis.com/theapp.res.beder.app/dev/bepartof/herobepartof.jpg')`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          
        }}>
         <h1 className="leading-[1.2] text-[50px] md:text-[64px] font-bold text-white text-center align-center ml-5 mr-5 justify-center content-center items-center">
         <span className="text-[#00F3CD] text-[15px] md:text-[21px] tracking-[.4em]">
  {locale == 'es' ? 'ELIGE TU PLAN' : 
   locale == 'en' ? 'CHOOSE YOUR PLAN' : 
   locale == 'fr' ? 'CHOISISSEZ VOTRE PLAN' : 
   locale == 'ru' ? 'Выбери свой вариант' : 'CHOOSE YOUR PLAN'}
</span>
<br></br>
<span className="text-white text-[50px] md:text-[75px]">
  {locale == 'es' ? 'Hazte Miembro' : 
   locale == 'en' ? 'Become a Member' : 
   locale == 'fr' ? 'Devenir Membre' : 
   locale == 'ru' ? 'Стань участником' : 'Become a Member'}
</span>

        </h1>
        </div>
        <div className="-mt-[40dvh] relative flex flex-col items-center justify-center content-center mx-auto pt-5 lg:inline-grid lg:grid-cols-2 md:gap-4 w-[99%] lg:w-[75%] ">

        
          <div
          onClick={() => scrolltoHash('TOPTRAVELLER')}
          className="transition-opacity duration-300 hover:opacity-90 text-white flex flex-col mx-0 lg:ml-44 p-10  text-[17px] md:text-[18px] bg-white text-center  items-center justify-center h-[450px] w-[80%] lg:w-[70%] mt-5
                          border-[#00F3CD] border-solid border-t-[5px]
                          after:content-[''] after:absolute after:left-[10%] after:lg:left-44 after:top-[45px] after:border-solid after:rounded-none 
                          after:border-[20px] after:border-t-[#00F3CD] after:border-l-[#00F3CD] after:border-white cursor-pointer">


            <div className="relative  items-center justify-center w-[100px]  h-[50px] ">
              <Image quality={80}  src={iconImg1} className="w-[90px] rounded-full transition-transform duration-300 transform hover:scale-110" alt="hand" />
              <Image quality={80}  src={iconFullImg1} className="w-[90px] rounded-full absolute top-0 left-0 opacity-0 transition-opacity duration-300 transform hover:opacity-100" alt="Nova hand" />
             </div>
      
            <h3 className="text-[#00F3CD] text-[23px] font-[500]  leading-[1.2rem] tracking-[2px] mt-12">
            TOP
            </h3>
            <h2 className="text-white text-[48px] md:text-[68px] font-[700] text-black">Travellers</h2>
            <p className="text-black">
  {locale == 'es' ? 'Si viajar no es lo que haces, sino lo que eres.' :
   locale == 'en' ? 'If travelling isn’t what you do, but who you are.' :
   locale == 'fr' ? 'Si voyager n’est pas ce que vous faites, mais qui vous êtes.' :
   locale == 'ru' ? 'Если путешествия – это не то, что ты делаешь, а то, кто ты есть на самом деле.' : 
   'If travelling isn’t what you do, but who you are.'}
  <br></br>

  {locale == 'es' ? 'Si te mueve compartirlo e inspirar a los demás.' :
   locale == 'en' ? 'If it moves you to share it and inspire others.' :
   locale == 'fr' ? 'Si cela vous motive, partagez-le et inspirez les autres.' :
   locale == 'ru' ? 'Если тебя вдохновляет делться этим и вдохновлять других.' :
   'If it moves you to share it and inspire others.'}
  <br></br>

  {locale == 'es' ? 'Eres de los nuestros, te estamos' :
   locale == 'en' ? 'You are one of us, we were waiting' :
   locale == 'fr' ? 'Tu es l\'un des nôtres, nous attendions' :
   locale == 'ru' ? 'Ты один из нас, мы ' :
   'You are one of us, we were waiting'}
  <br></br>

  {locale == 'es' ? 'esperando' :
   locale == 'en' ? 'for you.' :
   locale == 'fr' ? 'pour toi.' :
   locale == 'ru' ? 'тебя ждали!' :
   'for you.'}
</p>
   
      
         
          </div>
          <div 
          onClick={() => scrolltoHash('TOPBUSINESS')}
          className="transition-opacity duration-300 hover:opacity-90  text-white flex flex-col mx-[5%] p-10  text-[17px] md:text-[18px] bg-white text-center  items-center justify-center h-[450px] w-[80%] lg:w-[70%] mt-5 
                          border-[#00F3CD] border-solid border-b-[5px]
                          after:content-[''] after:absolute  after:bottom-[5px] after:right-[10.2%] lg:after:right-[12.35%] after:border-solid after:rounded-none 
                          after:border-[20px] after:border-b-[#00F3CD] after:border-r-[#00F3CD] after:border-white cursor-pointer">

            <div className="relative  items-center justify-center w-[100px]  h-[50px]">
              <Image quality={80}  src={iconImg2} className="w-[90px] rounded-full transition-transform duration-300 transform hover:scale-110" alt="hand" />
              <Image quality={80}  src={iconFullImg2} className="w-[90px] rounded-full absolute top-0 left-0 opacity-0 transition-opacity duration-300 transform hover:opacity-100" alt="Nova hand" />
            </div>
      
            <h3 className="text-[#00F3CD] text-[23px] font-[500]  leading-[1.2rem] tracking-[2px] mt-12">
            TOP
            </h3>
            <h2 className="text-white text-[48px] md:text-[68px] font-[700] text-black">Business</h2>
            <p className="text-black">
  {locale == 'es' ? 'Hoteles, restaurantes, bares, deportes de riesgo, guías ...' :
   locale == 'en' ? 'Hotels, restaurants, bars, extreme sports, guides …' :
   locale == 'fr' ? 'Hôtels, restaurants, bars, sports extrêmes, guides…' :
   locale == 'ru' ? 'Отели, рестораны, бары, экстремальные виды спорта, гиды…' :
   'Hotels, restaurants, bars, extreme sports, guides …'}
  <br></br>

  {locale == 'es' ? 'No importa cuál sea tu negocio, lo importante es que quieras dejar a tus clientes boquiabiertos con lo que haces, ' :
   locale == 'en' ? 'It doesn’t matter what your business is, if you want to leave your clients open-mouthed with what you do, ' :
   locale == 'fr' ? 'Peu importe votre activité, si vous voulez laisser vos clients bouche bée sur ce que vous faites, ' :
   locale == 'ru' ? 'Неважно, какой у тебя бизнес, главное – поразить клиентов тем, что ты делаешь, ' :
   'It doesn’t matter what your business is, if you want to leave your clients open-mouthed with what you do, '}
  <br></br>

  {locale == 'es' ? 'y nosotros somos expertos en ello.' :
   locale == 'en' ? 'we’re experts in that.' :
   locale == 'fr' ? 'et nous sommes des experts en la matière.' :
   locale == 'ru' ? 'и мы в этом эксперты.' :
   'we’re experts in that.'}
</p>

          </div>
        </div>
      </section>
      <section className="relative flex flex-col items-center justify-center   pt-5     w-full h-32 mb-5 mt-20"> 
        <div className="text-black text-center align-center  items-center justify-center  border-solid border-[1px] border-[#00F3CD] h-32 w-0 ">

        </div>

      </section>
      <section id="TOPTRAVELLER" className="relative flex flex-col items-center justify-center   pt-5     w-full h-32 mb-20"> 

        <h2 className="leading-[1.2] text-[50px] md:text-[64px] font-bold text-white text-center align-center ml-5 mr-5 justify-center content-center items-center">
         <span className="text-[#00F3CD] text-[15px] md:text-[21px] tracking-[.4em]">{locale == 'es' ? 'CONVIÉRTETE EN...' : 
 locale == 'en' ? 'BECOME A...' : 
 locale == 'fr' ? 'DEVENEZ UN...' : 
 locale == 'ru' ? 'СТАНЬТЕ...' : 
 'BECOME A...'}
</span><br></br>
         <span className="text-white text-[50px] md:text-[75px]">Top Traveller</span>
        </h2>
      </section>
      <section className="relative flex flex-col items-center justify-center   pt-5 md:inline-grid md:grid-cols-2 md:gap-4 mb-24">
        
      <div className="flex flex-col w-full h-[200px] md:h-[0px] md:hidden align-center text-center content-center justify-center items-center"
        
        style={{
          backgroundImage: `url('https://storage.googleapis.com/theapp.res.beder.app/dev/bepartof/bepartof1.webp')`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: '100% auto',
          backgroundPosition: 'center',
        }}>
      
      </div>
      <div className="text-white flex flex-col mx-14 text-[18px]">
  <p>
    {locale == 'es' ? 'Si eres un viajero apasionado de generar contenido top de travel, un videógrafo de travel profesional o un influencer de travel,' :
     locale == 'en' ? 'Whether you are a top content generation traveller, a professional videographer, or a travel influencer,' :
     locale == 'fr' ? 'Que vous soyez un voyageur de premier plan, un vidéaste professionnel ou un influenceur du voyage,' :
     locale == 'ru' ? 'Если ты увлеченный путешественник, создающий топовый контент, профессиональный видеограф или тревел-инфлюенсер,' :
     'Whether you are a top content generation traveller, a professional videographer, or a travel influencer,'}
    <br></br>
    WE WANT YOU!
    <br></br>
    
    {locale == 'es' ? 'Disfruta de una oportunidad única de ser promocionado como un Top Traveller, creando tu perfil, subiendo tu contenido de travel y colaborando con nosotros.' :
     locale == 'en' ? 'Enjoy a unique opportunity to be promoted as a Top Traveller by creating your profile, uploading your travel content and collaborating with us.' :
     locale == 'fr' ? 'Profitez d\'une opportunité unique d\'être promu Top Traveler en créant votre profil, en téléchargeant votre contenu de voyage et en collaborant avec nous.' :
     locale == 'ru' ? 'Воспользуйтесь уникальной возможностью стать Топовым Путешественником, создавая свой профиль, загружая свой тревел-контент и сотрудничая с нами.' :
     'Enjoy a unique opportunity to be promoted as a Top Traveller by creating your profile, uploading your travel content and collaborating with us.'}
    <br></br><br></br>

    {locale == 'es' ? 'Recompensamos a nuestros generadores top de contenido con una mayor visibilidad en nuestra comunidad y con una recompensa económica.' :
     locale == 'en' ? 'Our top content generators will join our Rewards Plan, with both higher visibility within our community and economic returns.' :
     locale == 'fr' ? 'Nos meilleurs générateurs de contenu rejoindront notre plan de récompenses, avec à la fois une plus grande visibilité au sein de notre communauté et des retombées économiques.' :
     locale == 'ru' ? 'Лучшие создатели контента получат повышенную видимость в нашем сообществе и финансовое вознаграждение.' :
     'Our top content generators will join our Rewards Plan, with both higher visibility within our community and economic returns.'}
  </p>
  <br></br>

  {locale == 'es' ? '¡Únete y déjanos tu contacto y tus redes para que podamos contactarte!' :
   locale == 'en' ? 'Join us and leave your contact and social media so we can reach out to you!' :
   locale == 'fr' ? 'Rejoignez-nous et laissez-nous vos coordonnées et vos réseaux sociaux afin que nous puissions vous contacter !' :
   locale == 'ru' ? 'Присоединяйтесь к нам, оставьте свои контакты и социальные сети, чтобы мы могли с вами связаться!' :
   'Join us and leave your contact and social media so we can reach out to you!'}
</div>

        <div className="flex flex-col h-[100%] w-[120%]  align-center text-center content-center justify-center items-center"
        
          style={{
            backgroundImage: `url('https://storage.googleapis.com/theapp.res.beder.app/dev/bepartof/bepartof1.webp')`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: '100% auto',
            backgroundPosition: 'center',
          }}>
        
        </div>
    </section>
    <section id="TOPBUSINESS"className="bg-white relative flex flex-col items-center justify-center   pt-5     w-full h-32 mb-0 pb-32 pt-20"> 

      <h2 className="leading-[1.2] text-[50px] md:text-[64px] font-bold text-white text-center align-center ml-5 mr-5 justify-center content-center items-center">
      <span className="text-[#00F3CD] text-[15px] md:text-[21px] tracking-[.4em]">{locale == 'es' ? 'PARA...':'FOR...'}</span><br></br>
      <span className="text-black text-[50px] md:text-[75px]">Businesses</span>
      </h2>
    </section>
    <section className="relative flex flex-col items-center justify-center bg-white  pt-5 md:inline-grid md:grid-cols-2 md:gap-4 pb-32">
    <div className="flex flex-col w-full h-[200px] md:h-[100%] md:w-[120%]    align-center text-center content-center justify-center items-center md:-ml-32 mb-10 md:mb-0"
        
        style={{
          backgroundImage: `url('https://storage.googleapis.com/theapp.res.beder.app/dev/bepartof/bepartof2.webp')`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: '100% auto',
          backgroundPosition: 'center ',
        }}>
      
      </div>
      <div className="text-black flex flex-col mx-14 text-[18px]">
  <p>
    {locale == 'es' ? 'Conseguir un cliente es más difícil que nunca. Y es que todos buscamos vivir experiencias. Por ello, es clave conectar con la emoción de los viajeros y, en beder, hemos dado con la clave.' :
     locale == 'en' ? 'Getting clients is more difficult than ever. The thing is we all want to live experiences. That’s why the key is to connect with the travellers’ feeling, and, in beder, we’ve found how.' :
     locale == 'fr' ? 'Trouver des clients est plus difficile que jamais. Le fait est que nous voulons tous vivre des expériences. C’est pourquoi l’essentiel est de se connecter avec le ressenti des voyageurs et, à Beder, nous avons trouvé comment.' :
     locale == 'ru' ? 'Привлечь клиентов сложнее, чем когда-либо. Дело в том, что все мы хотим переживать новые впечатления. Вот почему важно установить эмоциональную связь с путешественниками, и в Beder мы нашли способ сделать это.' :
     'Getting clients is more difficult than ever. The thing is we all want to live experiences. That’s why the key is to connect with the travellers’ feeling, and, in beder, we’ve found how.'}
  </p>

  <p>
    {locale == 'es' ? 'Consigue que tus clientes sientan esa experiencia desde su móvil, transmite esa emoción y, en ese preciso momento, genera leads cualificados para tu web o tu canal de conversión preferido.' :
     locale == 'en' ? 'Get your clients to really feel that experience from their phone, transmit that feeling and, in that precise moment, generate qualified leads for your web or favourite channel conversion.' :
     locale == 'fr' ? 'Amenez vos clients à ressentir réellement cette expérience depuis leur téléphone, transmettez cette sensation et, à ce moment précis, générez des prospects qualifiés pour la conversion de votre site Web ou de votre canal préféré.' :
     locale == 'ru' ? 'Позвольте вашим клиентам почувствовать этот опыт через их телефон, передайте эту эмоцию и в этот самый момент привлекайте квалифицированные лиды на ваш сайт или предпочтительный канал конверсии.' :
     'Get your clients to really feel that experience from their phone, transmit that feeling and, in that precise moment, generate qualified leads for your web or favourite channel conversion.'}
  </p>

  <br></br>

  <p>
    {locale == 'es' ? 'Crea tu propio perfil, sube tu contenido y muéstrale a nuestra comunidad de Travellers lo que puedes ofrecer, alcanzando una mayor awareness y visibilidad para tu negocio.' :
     locale == 'en' ? 'Create your own profile, upload your content, and show our Travellers community what you’ve got to offer, reaching a higher awareness and visibility for your business.' :
     locale == 'fr' ? 'Créez votre propre profil, téléchargez votre contenu et montrez à notre communauté de voyageurs ce que vous avez à offrir, atteignant ainsi une plus grande notoriété et visibilité pour votre entreprise.' :
     locale == 'ru' ? 'Создайте свой профиль, загрузите свой контент и покажите сообществу путешественников, что вы можете предложить, увеличивая узнаваемость и видимость вашего бизнеса.' :
     'Create your own profile, upload your content, and show our Travellers community what you’ve got to offer, reaching a higher awareness and visibility for your business.'}
  </p>

  <br></br>

  <p>
    {locale == 'es' ? '¡Averigua cómo lo han hecho nuestros partners!' :
     locale == 'en' ? 'Find out how our partners did!' :
     locale == 'fr' ? 'Découvrez comment nos partenaires ont fait !' :
     locale == 'ru' ? 'Узнайте, как это сделали наши партнеры!' :
     'Find out how our partners did!'}
  </p>
</div>

       
    </section>
    <section className="relative flex flex-col items-center justify-center   pt-0  -mb-4 md:mb-1">
      <div className="flex flex-row h-screen overflow-x-auto w-screen align-center text-center content-center justify-center items-center "
        
        style={{
          backgroundImage: `url('https://storage.googleapis.com/theapp.res.beder.app/dev/bepartof/bepartof3.webp')`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: ' cover',
          backgroundPosition: 'center',
        
          opacity: 0.7,
          
        }}>
     
        </div>
   
    
  


        <h3 className="z-10 -mt-[108dvh] leading-[1.2] text-[50px] md:text-[64px] font-bold text-white text-center align-center ml-5 mr-5 justify-center content-center items-center">
        <div className="relative flex flex-col items-center justify-center       w-full   "> 
        <div className="text-black text-center align-center  items-center justify-center  border-solid border-[1px] border-[#00F3CD] h-32 w-0 ">

        </div>

      </div>
        
      <span className="text-[#00F3CD] text-[15px] md:text-[21px] tracking-[.4em]">
  {locale == 'es' ? 'DÉJANOS TU INFORMACIÓN DE CONTACTO' :
   locale == 'en' ? 'LEAVE US YOUR CONTACT INFORMATION' :
   locale == 'fr' ? 'LAISSEZ-NOUS VOS COORDONNÉES' :
   locale == 'ru' ? 'ОСТАВЬТЕ НАМ ВАШИ КОНТАКТЫ' :
   'LEAVE US YOUR CONTACT INFORMATION'}
</span>
<br></br>

<span className="text-white text-[44px] md:text-[52px]">
  {locale == 'es' ? 'Encuentra tu Plan' :
   locale == 'en' ? 'Tell us which Plan better' :
   locale == 'fr' ? 'Dites-nous quel plan est le meilleur' :
   locale == 'ru' ? 'Расскажите нам, какой план лучше всего подходит вам' :
   'Tell us which Plan better'}
</span>
<br></br>

<span className="text-[#00F3CD] text-[15px] md:text-[21px] tracking-[.4em]">
  {locale == 'es' ? '' :
   locale == 'en' ? 'suits you,' :
   locale == 'fr' ? 'vous convient,' :
   locale == 'ru' ? 'вам подходит,' :
   'suits you,'} 
  <span className="text-white">
    {locale == 'es' ? 'y forma parte de' :
     locale == 'en' ? 'and' :
     locale == 'fr' ? 'et forme une partie de' :
     locale == 'ru' ? 'и СЛЕДИ ЗА НАМИ' :
     'and'}
  </span> 
  {locale == 'es' ? ' beder!' :
   locale == 'en' ? 'join us!' :
   locale == 'fr' ? 'beder' :
   locale == 'ru' ? 'beder!' :
   'join us!'}
</span>
<br></br>

        </h3>
        <div className="flex items-center  z-10">
          <div key={'opt1'} className={ " bg-white w-[200px] h-[60px] text-black font-bold rounded-md text-center align-center  content-center justify-center items-center m-auto mr-[5px] "}>
              <input
                type="radio"
                id={'opt1'}
                name="dynamicRadio"
                value={'opt1'}
                defaultChecked={true}
                checked={selectedOption === 'opt1'}
                onChange={handleOptionChange}
                className="w-6 h-6 form-radio accent-[#00F3CD]  top-[7px] relative"
              />
               <label className={(selectedOption == 'opt1' ? 'border-primary-color': 'border-transparent') + " border-b-4 ml-2 m-auto  text-center align-center  content-center justify-center items-center top-[0px] relative"} htmlFor={'opt1'}>TOP TRAVELER</label>
            </div>
            <div key={'opt2'} className={ " bg-white w-[200px] h-[60px] text-black font-bold rounded-md text-center align-center  content-center justify-center items-center m-auto ml-[5px]"}>
              <input
                type="radio"
                id={'opt2'}
                name="dynamicRadio"
                value={'opt2'}
                checked={selectedOption === 'opt2'}
                onChange={handleOptionChange}
                typeof="radio"
                className="m-auto w-6 h-6 form-radio accent-[#00F3CD] text-center align-center  content-center justify-center items-center top-[7px] relative"
              />
              <label className={(selectedOption == 'opt2' ? 'border-primary-color': 'border-transparent') + " border-b-4 ml-2 m-auto  text-center align-center  content-center justify-center items-center top-[0px] relative"} htmlFor={'opt2'}>BUSINESSES</label>
            </div>
        </div>
        <div className="bg-white w-[500px] rounded-md mt-4 text-black z-10 ">
       
          <div className={(selectedOption === 'opt1' ? '' : 'hidden') + " mt-10 relative w-[400px] min-w-[200px] h-12  m-auto  text-center align-center  content-center justify-center items-center "}>
          
            <input
              className="peer w-[80%] md:w-full h-full bg-transparent text-blue-gray-700
               font-sans font-normal outline 
               outline-1 focus:outline-0 
               disabled:bg-blue-gray-50 disabled:border-0
                transition-all placeholder-shown:border
                 placeholder-shown:border-blue-gray-200 
                 placeholder-shown:border-t-blue-gray-200 border
                   text-sm
                   px-3 py-2.5 rounded-[7px] border-blue-gray-200
                    focus:border-gray-900"

              placeholder={locale == 'es' ? 'Nombre Traveller' : 
                locale == 'en' ? 'Traveller name' : 
                locale == 'fr' ? 'Nom du voyageur' : 
                locale == 'ru' ? 'Имя путешественника' : 
                'Traveller name'}
               
              value={travelerName}
              onChange={handleTravelerName}
              />
            

          </div>
          <div className={(selectedOption === 'opt2' ? '' : 'hidden') + " mt-10 relative w-[400px] min-w-[200px] h-12  m-auto  text-center align-center  content-center justify-center items-center "}>
          
          <input
              className="peer w-[80%] md:w-full h-full bg-transparent text-blue-gray-700
               font-sans font-normal outline 
               outline-1 focus:outline-0 
               disabled:bg-blue-gray-50 disabled:border-0
                transition-all placeholder-shown:border
                 placeholder-shown:border-blue-gray-200 
                 placeholder-shown:border-t-blue-gray-200 border
                   text-sm
                   px-3 py-2.5 rounded-[7px] border-blue-gray-200
                    focus:border-gray-900"

              placeholder={locale == 'es' ? 'Nombre Business':locale == 'en' ? 'Business name' : locale=='ru' ? 'Название компании' : `Nom de l'entreprise`}
              value={businessName}
              onChange={handleBusinessName}
              />
        </div>
          <div className="mt-8 relative w-[400px] min-w-[200px] h-12  m-auto  text-center align-center  content-center justify-center items-center ">
          <input
              className="peer w-[80%] md:w-full h-full bg-transparent text-blue-gray-700
               font-sans font-normal outline 
               outline-1 focus:outline-0 
               disabled:bg-blue-gray-50 disabled:border-0
                transition-all placeholder-shown:border
                 placeholder-shown:border-blue-gray-200 
                 placeholder-shown:border-t-blue-gray-200 border
                   text-sm
                   px-3 py-2.5 rounded-[7px] border-blue-gray-200
                    focus:border-gray-900"

              placeholder=" Email" 
              value={email}
              onChange={handleEmail}
              />
          </div>
          <div className={(selectedOption === 'opt2' ? '' : 'hidden') + " mt-8 relative w-[400px] min-w-[200px] h-12  m-auto  text-center align-center  content-center justify-center items-center "}>
          
          <input
              className="peer w-[80%] md:w-full h-full bg-transparent text-blue-gray-700
               font-sans font-normal outline 
               outline-1 focus:outline-0 
               disabled:bg-blue-gray-50 disabled:border-0
                transition-all placeholder-shown:border
                 placeholder-shown:border-blue-gray-200 
                 placeholder-shown:border-t-blue-gray-200 border
                   text-sm
                   px-3 py-2.5 rounded-[7px] border-blue-gray-200
                    focus:border-gray-900"

              placeholder=" Web" 
              value={web}
              onChange={handleWeb}
              />
        </div>
          <div className="mt-8 relative w-[400px] min-w-[200px] h-12  m-auto  text-center align-center  content-center justify-center items-center ">
          <input
              className="peer w-[80%] md:w-full h-full bg-transparent text-blue-gray-700
               font-sans font-normal outline 
               outline-1 focus:outline-0 
               disabled:bg-blue-gray-50 disabled:border-0
                transition-all placeholder-shown:border
                 placeholder-shown:border-blue-gray-200 
                 placeholder-shown:border-t-blue-gray-200 border
                   text-sm
                   px-3 py-2.5 rounded-[7px] border-blue-gray-200
                    focus:border-gray-900"

              placeholder=" Instagram" 
              value={instagram}
              onChange={handleInstragram}
              />
          </div>
          <div className="mt-8 mb-10 relative w-[400px] min-w-[200px] h-12 m-auto  text-center align-center  content-center justify-center items-center ">
          <input
              className="peer w-[80%] md:w-full h-full bg-transparent text-blue-gray-700
               font-sans font-normal outline 
               outline-1 focus:outline-0 
               disabled:bg-blue-gray-50 disabled:border-0
                transition-all placeholder-shown:border
                 placeholder-shown:border-blue-gray-200 
                 placeholder-shown:border-t-blue-gray-200 border
                   text-sm
                   px-3 py-2.5 rounded-[7px] border-blue-gray-200
                    focus:border-gray-900"

              placeholder=" TikTok" 
              value={tiktok}
              onChange={handleTiktok}
              />
          </div>
          <div className="mt-8 mb-10 relative w-[400px] min-w-[200px] h-12  md:m-auto  mx-20 ">
            <input type="checkbox" ></input>
            <label className="ml-4 font-semibold">
  {locale == 'es' ? 'Acepto la Política de Privacidad' :
   locale == 'en' ? 'I accept the Privacy Policy' :
   locale == 'fr' ? 'J’accepte la Politique de Confidentialité' :
   locale == 'ru' ? 'Я принимаю Политику конфиденциальности' :
   'I accept the Privacy Policy'}
</label>

          </div>
          <div className="mt-8 mb-10 relative w-[400px] min-w-[200px] h-12  m-auto  text-center align-center  content-center justify-center items-center  rounded-[100px]">
            <button
              className="!rounded-[400px] p-3 py-2 text-md md:text-xl font-semibold text-black hover:text-white uppercase md:text-sm bg-primary-color !w-1/2 md:w-auto"
              onClick={onSend}
            >
             {locale == 'es' ? 'ÚNETE A BEDER' : 
 locale == 'en' ? 'JOIN BEDER' : 
 locale == 'fr' ? 'REJOIGNEZ BEDER' : 
 locale == 'ru' ? 'ПРИСОЕДИНЯЙТЕСЬ К BEDER' : 
 'JOIN BEDER'}

            </button>
          </div>
        </div>


 

    </section>
    <section className="relative flex flex-col items-center justify-center   pt-0  ">
      
      <div className="flex flex-row h-[500px] overflow-x-auto w-screen align-center text-center content-center justify-center items-center"
      
      style={{
        backgroundImage: `url('https://storage.googleapis.com/theapp.res.beder.app/dev/bepartof/bepartof4.jpg')`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        
      }}>
   <h4 className="text-white font-bold text-[42px] md:text-[72px] mx-16">
  {locale == 'es' ? 'La' : 
   locale == 'en' ? 'The' : 
   locale == 'fr' ? `L'` : 
   locale == 'ru' ? 'Приключение' : 
   'The'} 
  <span className="text-[#00f3cd]">
    {locale == 'es' ? ' aventura' : 
     locale == 'en' ? ' adventure' : 
     locale == 'fr' ? ' aventure' : 
     locale == 'ru' ? '' : 
     ' adventure'}
  </span> 
  {locale == 'es' ? ' empieza aquí' : 
   locale == 'en' ? ' starts here' : 
   locale == 'fr' ? ' commence ici' : 
   locale == 'ru' ? ' начинается здесь' : 
   ' starts here'}
</h4>

      </div>
      </section>
    <section className="bg-white h-10 -mb-20">  
    </section>
    </MainLayout>

  );
}


